<template>

  <div class="login container">
    <b-form class="form-signin" @submit.prevent="onSubmit">
      <img class="logo mb-3" src="../assets/logo-ecoopex.png">
      <!-- <h1 class="h3 mb-3 title">{{ title }}</h1> -->

      <b-form-group>

        <b-row class="justify-content-md-center">
          <b-col sm="6">

            <!-- Using slots -->
            <b-input-group>
              <b-input-group-text slot="prepend">
                <strong class="text-dark">
                  <i class="fas fa-user"></i>
                </strong>
              </b-input-group-text>
              <b-form-input ref="usuarioInput" id="usuarioInput" type="text" v-model="form.nombre" required placeholder="# Documento" class="form-control" autofocus autocomplete="off">
              </b-form-input>
            </b-input-group>

            <!-- Using slots -->
            <b-input-group class="mt-2">
              <b-input-group-text slot="prepend">
                <strong class="text-dark">
                  <i class="fas fa-unlock-alt"></i>
                </strong>
              </b-input-group-text>
              <b-form-input id="claveInput" type="password" v-model="form.clave" required placeholder="Tu clave" class="form-control">
              </b-form-input>
            </b-input-group>

            <b-button type="submit" variant="primary" class="btn btn-lg btn-primary btn-block" :disabled="false">
              <i class="fas fa-sign-in-alt"></i> Ingresar
            </b-button>

          </b-col>

        </b-row>

        <b-row>
          <b-col>
            <b-input-group class="mt-2">
              <b-alert :show="dismissCountDown" dismissible variant="danger" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
                <p>Error: {{textAlert}}.</p>
                <b-progress variant="danger" :max="dismissSecs" :value="dismissCountDown" height="2px">
                </b-progress>
              </b-alert>
            </b-input-group>
          </b-col>
        </b-row>

      </b-form-group>

      <p class="mt-3 mb-3 text-muted font-weight-bold">{{ title }} &copy; {{currentYear}} | e-Coopex v: {{ vue_app_version }} </p>
      <!-- <p class="mt-5 mb-3 text-muted">Powered by Vamyal&reg; S.A.</p> -->
    </b-form>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import md5 from 'md5';

import _ from "lodash";

export default {
  name: "login",
  data() {
    return {
      title: "Coopexsanjo Ltda.",
      form: {
        nombre: null,
        clave: null
      },
      posicion: {
        coords: {
          latitude: 0.00,
          longitude: 0.00,
          accuracy: 0
        }
      },
      permitir: true,
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      textAlert: null,
      currentYear: '20__',
      dashboards: [],
      vue_app_version: process.env.VUE_APP_VERSION
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(message) {
      this.textAlert = message;
      this.dismissCountDown = this.dismissSecs;
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.posicion.coords.latitude = position.coords.latitude;
          this.posicion.coords.longitude = position.coords.longitude;
          this.posicion.coords.accuracy = position.coords.accuracy;
          //console.log(JSON.parse(JSON.stringify(this.posicion.coords)));
        }, (error) => {
          //console.log(error.message);
          switch (error.code) {
            case error.PERMISSION_DENIED:
              // si ocurre esto NO puede hacer login
              this.permitir = false;
              this.showAlert('Por seguridad, debe permitir la geolocalización.')
              //x.innerHTML = "El usuario bloqueo el acceso a la Ubicación."
              break;
            case error.POSITION_UNAVAILABLE:
              // si ocurre esto si puede pasar - login
              //x.innerHTML = "Ubicación no disponible."
              break;
            case error.TIMEOUT:
              // si ocurre esto si puede pasar - login
              //x.innerHTML = "El tiempo de espera ha expirado."
              break;
            case error.UNKNOWN_ERROR:
              // si ocurre esto si puede pasar - login
              //x.innerHTML = "Ha ocurrido un error desconocido."
              break;
          }
        });
      }
    },
    onSubmit() {
      axios
        .post(`${process.env.VUE_APP_API_URL}/login`, {
          nombre: this.form.nombre,
          clave: md5(this.form.clave),
          latitude: this.posicion.coords.latitude,
          longitude: this.posicion.coords.longitude
        }, {})
        .then(login => {
          //console.log(login); 
          window.localStorage.setItem("token", login.data.token);
          window.localStorage.setItem("usuarioId", login.data.usuarioId);
          window.localStorage.setItem("usuario", this.form.nombre);
          window.localStorage.setItem("nro_socio", login.data.nro_socio);
          window.localStorage.setItem("nombre", login.data.nombre);
          window.localStorage.setItem("apellido", login.data.apellido);

          if (login.data.ultimo_acceso) {
            window.localStorage.setItem("ultimo_acceso", login.data.ultimo_acceso);
          }

          this.$router.push({ name: "Welcome" });
        })
        .catch(err => {
          this.showAlert(err.response.data.message);
          this.$refs.usuarioInput.$el.focus();
        });

    },
  },
  created(){
    const fecha = new Date();
    this.currentYear = fecha.getFullYear();
  },
  mounted() {
    this.$refs.usuarioInput.$el.focus();
    this.getLocation();
    //console.log(process.env);
  }
};
</script>

<style scoped>
.title {
  color: white;
  font-size: 2.5em;
  font-weight: bold !important;
}
.login {
  margin-top: 2em;
  background: linear-gradient(to top, rgb(206, 207, 207), rgb(7, 82, 137));
  border-radius: 10px;
  border: 5px solid rgba(200, 201, 201, 0.733);
}
.logo {
  max-width: 200px;
  border-radius: 49%;
}
.text-muted {
  color: #ffffffff!important;
}
.form-signin {
  width: 100%;
  max-width: 720px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="text"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.input-group > .input-group-prepend > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 46px;
}
.input_select_vamyal {
  background-clip: padding-box;
  background-color: #fff;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
  color: #495057;
  display: block;
  font-size: 1.2rem;
  font-weight: 600;
  height: calc(2.25rem + 2px);
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  width: 100%;
}
</style>